module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_default____6e7f688663afd988deacd133a881701b.png";